import { TrackingInfoUtms } from '@/modules/simulator/api'
import { ReadonlyURLSearchParams } from 'next/navigation'

const getTrackingInfoUtms = (
  searchParams: ReadonlyURLSearchParams
): TrackingInfoUtms => {
  return {
    utmSource: searchParams.get('utm_source') || undefined,
    utmMedium: searchParams.get('utm_medium') || undefined,
    utmCampaign: searchParams.get('utm_campaign') || undefined,
    utmCampaignName: searchParams.get('utm_campaign_name') || undefined,
    utmTerm: searchParams.get('utm_term') || undefined,
    utmContent: searchParams.get('utm_content') || undefined,
    utmAdId: searchParams.get('utm_ad_id') || undefined,
    utmAdSetId: searchParams.get('utm_ad_set_id') || undefined,
    utmCampaignId: searchParams.get('utm_campaign_id') || undefined,
    gclid: searchParams.get('gclid') || undefined,
    utmAdSet: searchParams.get('utm_ad_set') || undefined,
    utmBlog: searchParams.get('utm_blog') || undefined
  }
}

export { getTrackingInfoUtms }
